import { render } from "./RedirectElement.vue?vue&type=template&id=3e2c8eb0&scoped=true"
import script from "./RedirectElement.vue?vue&type=script&lang=js"
export * from "./RedirectElement.vue?vue&type=script&lang=js"

import "./RedirectElement.vue?vue&type=style&index=0&id=3e2c8eb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2c8eb0"]])

export default __exports__